var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


export {$662ccaf2be4c25b3$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
